import CheckIcon from '@mui/icons-material/Check';
import { ListItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';

type PropsType = {
  primary: string;
};

const FeatureListItem = ({ primary }: PropsType) => {
  const theme = useTheme();

  return (
    <ListItem disablePadding>
      <ListItemIcon sx={{ minWidth: theme.spacing(4) }}>
        <CheckIcon fontSize="small" color="inherit" />
      </ListItemIcon>
      <ListItemText
        primary={primary}
        primaryTypographyProps={{ fontSize: 12 }}
      />
    </ListItem>
  );
};

export default FeatureListItem;
